import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';

import { Button } from '@/components/core/Button';

interface LicensesBarProps {
    showBuyLicenses: boolean;
    licensesUsedText?: string;
    exporting: boolean;
    onBuyLicenses: () => void;
    onExport: () => void;
    buyLabel: string;
    exportLabel: string;
}

export function LicensesBar({
    showBuyLicenses,
    licensesUsedText,
    exporting,
    onBuyLicenses,
    onExport,
    buyLabel,
    exportLabel,
}: LicensesBarProps) {
    return (
        <div id="user-licenses-div" className="tw-mb-4 tw-flex tw-w-full tw-items-center">
            {showBuyLicenses && licensesUsedText && (
                <span className="tw-text-t-sm lg:tw-text-t-base tw-text-t-primary">{licensesUsedText}</span>
            )}
            <div className="tw-ml-auto tw-flex tw-items-center tw-gap-3">
                {showBuyLicenses && (
                    <div className="tw-flex tw-items-center">
                        <Button type="button" variant='outline' onClick={onBuyLicenses}>
                            {buyLabel}
                        </Button>
                    </div>
                )}
                <Button
                    id="export-users-btn"
                    variant="outline"
                    hasIcon
                    icon={ArrowDownTrayIcon}
                    loading={exporting}
                    onClick={onExport}
                >
                    {exportLabel}
                </Button>
            </div>
        </div>
    );
}
